import React, { useEffect, useState } from "react";
import CustomBreadcrumbs from "../breadcrumb";
import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Table,
} from "react-bootstrap";
import * as yup from "yup";

import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import yupTypeValidator from "../../utils/YupTypeValidator";
import { GenericFields } from "../group-reservation/GenericFields";

import { CashFields } from "./fields/CashFields";
import { parsedUser } from "../../utils/GetCurrentUser";
import API from "../../api/api";
import { GetDataOfJSON } from "../../utils/GetDataOfJSON";

import { FormatMoney } from "../../utils/FormatMoney";
import { PrintCashClosing } from "./PrintCashClosing";
import Loading from "../Loading";
import { useToast } from "../../contexts/toast";
import { confirmAlert } from "react-confirm-alert";

const CashClosingContainer = ({ routeName }) => {
  const { t } = useTranslation();

  const user = parsedUser();
  const toast = useToast();

  const [showPrint, setShowPrint] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fields, setFields] = useState(CashFields);
  const [accounts, setAccounts] = useState([]);
  const [header, setHeader] = useState({});
  const [isInProcess, setIsInProcess] = useState(
    localStorage.getItem("status_cash") === "true" ? true : false
  );
  const [validationsSchema, setValidationSchema] = useState(null);
  const [quantities, setQuantities] = useState({});
  const [totals, setTotals] = useState({});
  const sumTotals = Object.keys(totals).reduce((acc, total) => {
    const account = accounts[total][0];
    return acc + totals[total] * account.RateValue;
  }, 0);

  const handleQuantityChange = (account, denomination, value) => {
    const newQuantities = {
      ...quantities,
      [`${account}-${denomination}`]: value,
    };

    console.log(newQuantities, account, accounts);
    setQuantities(newQuantities);

    // Calculate new total for the account
    let newTotal = 0;
    accounts[account]
      .filter((item) => item.CurrencyCode === account)
      .forEach((item) => {
        console.log(item, account);
        newTotal +=
          item.Value * (newQuantities[`${account}-${item.Denomination}`] || 0);
      });
    //   }

    //   (acc, item) =>
    //     acc +
    //     item.Value * (newQuantities[`${account}-${item.Denomination}`] || 0),
    //   0
    // );

    setTotals({
      ...totals,
      [account]: newTotal,
    });
  };

  const RequestAccounts = async () => {
    try {
      let queryString = `IdUser=${user.IdUser}&Token=${user.Token}`;

      let queryData = {
        Data: null,
      };

      let requestAPI = await API.postAction(
        "/api/CashierClosing/BringCurrencies?" + queryString,
        queryData
      );
      console.log(requestAPI);

      let result = GetDataOfJSON(requestAPI, "data", 0, "JSONData", 0).Record;

      let groupByCurrencyCode = Object.groupBy(
        result,
        ({ CurrencyCode }) => CurrencyCode
      );

      setAccounts(groupByCurrencyCode);
    } catch (error) {
      console.error(error);
    }
  };

  const changeToOnlyReadFields = () => {
    const updatedFields = fields.map((item) => {
      if (
        localStorage.getItem("status_cash") === "true" &&
        item.FieldName === "Cashfund"
      ) {
        return { ...item, ReadOnly: true };
      }
      return item;
    });
    setFields(updatedFields);
  };

  const SaveHeader = async (obj) => {
    try {
      setIsInProcess(true);
      let queryString = `IdUser=${user.IdUser}&Token=${user.Token}`;

      let queryData = {
        Data: `@IdBussinessUnit=${user.IdBusinessUnit}, @Comment='${obj.comment || ""}'`,
      };
      console.log(queryData);

      let requestAPI = await API.postAction(
        "api/CashierClosing/SaveHeader?" + queryString,
        queryData
      );

      console.log("saveheader ", requestAPI);

      if (requestAPI.status === 200) {
        let result = GetDataOfJSON(requestAPI, "data", 0, "JSONData", 0);

        console.log(result);

        localStorage.setItem("status_cash", true);
        console.log("result", result);
        setHeader(result.Record[0]);

        fillFormikObject();

        toast({
          type: "success",
          message: t("Open cashier!"),
        });
      }
    } catch (error) {
      toast({
        type: "error",
        message: t("Error to Open Cash"),
      });
      console.error(error);
    }
  };

  const SaveDetails = async () => {
    try {
      setIsLoading(true);
      let queryString = `IdUser=${user.IdUser}&Token=${user.Token}`;

      for (const account in accounts) {
        for (const byAccount in accounts[account]) {
          let item = accounts[account][byAccount];
          console.log("header", header);
          let queryData = {
            Data: `@GUIDClosingHeader='${header.GUID}', @GUIDDenominations='${
              accounts[account][byAccount].GUIDDenominations
            }', @Quantity=${
              quantities[`${account}-${item.Denomination}`]
            }, @TotalAmount=${item.Total}, @CurrencyRateValue=${
              item.RateValue
            }`,
          };

          /* let requestAPI = */ await API.postAction(
            "api/CashierClosing/SaveDetails?" + queryString,
            queryData
          );
        }
      }
      toast({
        type: "success",
        message: t("Details saved successfully"),
      });
      setIsLoading(false);
      setIsInProcess(false);

      localStorage.setItem("status_cash", false);
    } catch (error) {
      setIsLoading(false);
      toast({
        type: "error",
        message: t("Error save data"),
      });
      console.error(error);
    }
  };

  const GenerateClousure = async (obj) => {
    try {
      let queryString = `IdUser=${user.IdUser}&Token=${user.Token}`;
      console.log("header", header);
      let queryData = {
        Data: `@GUIDClosingHeader='${header.GUID}'`,
      };

      let requestAPI = await API.postAction(
        "api/CashierClosing/SaveDetails?" + queryString,
        queryData
      );

      console.log(requestAPI);
      console.log("🚀 ~ GenerateClousure ~ header:", header)

      toast({
        type: "success",
        message: t("Close Cashier!"),
      });
      setShowPrint(true);
    } catch (error) {
      toast({
        type: "error",
        message: t("Error save data"),
      });
      console.error(error);
    }
  };

  const handleSubmit = async (obj, event) => {
    confirmAlert({
      closeOnClickOutside: false,
      message: t("Are you sure you want to Open the Cash?"),
      buttons: [
        {
          label: t("Si"),
          onClick: async () => {
            SaveHeader(obj);
            changeToOnlyReadFields();
          },
        },
        {
          label: t("No"),
        },
      ],
    });
  };

  const updateField = (fieldName, fieldValue) => {
    console.log(fieldName, fieldValue);
    formik.setFieldValue(fieldName, fieldValue);
  };

  const fillFormikObject = () => {
    // console.log("record", record, "model", fields);
    if (fields) {
      fields.forEach((item) => {
        if (item.FieldName === "IdBusinessUnit") {
          formik.setFieldValue(item.FieldName, user.IdBusinessUnit * 1);
        } else if (item.FieldName === "name") {
          formik.setFieldValue(item.FieldName, user.Username);
        } else if (item.FieldName === "OpeningDate") {
          formik.setFieldValue(item.FieldName, new Date());
        }
      });
    }
  };

  const prepareFormikObject = () => {
    // console.log("Preparing formik object", section);
    let initialObject = {};
    let initialObjectValidation = {};

    if (fields) {
      fields.forEach((item) => {
        initialObject[item.FieldName] = item.value;

        if (item.FieldName === "Cashfund") {
          item.ReadOnly = isInProcess;
        }

        if (item.Required) {
          initialObjectValidation[item.FieldName] = yupTypeValidator(item);
        }
      });
    }
    // console.log(initialObject);
    formik.initialValues = initialObject;
    setValidationSchema(yup.object(initialObjectValidation));
    //Nowws
  };

  const formik = useFormik({
    initialValues: header && header.length > 0 ? header : {},
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: validationsSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    const initialQuantities = {};
    const initialTotals = {};
    Object.keys(accounts).forEach((account) => {
      accounts[account]
        .filter((item) => item.CurrencyCode === account)
        .forEach((item) => {
          initialQuantities[`${account}-${item.Denomination}`] = 0;
        });

      initialTotals[account] = 0;
    });
    setQuantities(initialQuantities);
    setTotals(initialTotals);
  }, [accounts]);
  useEffect(() => {
    RequestAccounts();
  }, []);

  useEffect(() => {
    prepareFormikObject();
    fillFormikObject();
  }, [fields]);
  return (
    <>
      <CustomBreadcrumbs pathTitle={routeName} />
      {
        showPrint &&
        <PrintCashClosing
          // GUIDClosingHeader={"3F412102-94D4-4F71-A226-DE9225F23EDB"}
          GUIDClosingHeader={header?.GUID}
          show={showPrint}
          toggle={() => setShowPrint(false)}
        />
      }

      <Container className="mt-0 pt-0 mb-5 mh-100">
        <Row className="mx-3">
          <Col xs={12}>
            <div className="d-flex flex-wrap align-items-center justify-content-between mb-2 mt-2">
              {isLoading ? (
                <React.Fragment>
                  <div className="">
                    <div
                      className="w-25 mx-auto my-1"
                      style={{ paddingTop: "" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">
                          {t("Loading")}...
                        </span>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="d-flex align-items-center my-1">
                    {/* <i className={section.FormIcon + " me-3 fa-2x"}></i> */}
                    <i className="dx-icon fa-solid fa-money-bill-trend-up me-3 fa-2x" />
                    <div className="d-flex flex-column">
                      <h5 className={"my-1"}>{t("Cash Management")}</h5>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </div>

            {isInProcess ? (
              <Button
                variant="outline-dark"
                size="lg"
                onClick={async () => {
                  confirmAlert({
                    closeOnClickOutside: false,
                    message: t(
                      "Are you sure you want to Save Details and Generate Clousure?"
                    ),
                    buttons: [
                      {
                        label: t("Si"),
                        onClick: async () => {
                          await SaveDetails();
                          await GenerateClousure();
                        },
                      },
                      {
                        label: t("No"),
                      },
                    ],
                  });
                }}
                /* disabled={isLoading} */
              >
                {isLoading ? (
                  <Loading />
                ) : (
                  <>
                    {t("Close Cash")}
                    <br />
                    <i className={"fa-solid fa-sack-dollar"} />
                  </>
                )}
              </Button>
            ) : (
              <Button
                form="thisForm"
                variant="outline-success"
                size="lg"
                type="submit"
              >
                {t("Open Cash")}
                <br />
                <i className={"fa-solid fa-play"} />
              </Button>
            )}
            {/* <Button
              className="ms-2"
              variant="outline-primary"
              size="md"
              onClick={() => {
                setShowPrint(true);
              }}
            >
              Test Print
            </Button> */}
            <hr />
          </Col>

          <Col xs={6}>
            <Row>
              <Col xs={12}>
                <Form onSubmit={formik.handleSubmit} id="thisForm">
                  <Row>
                    <GenericFields
                      fields={fields}
                      values={formik.values}
                      errors={formik.errors}
                      touched={formik.touched}
                      updateFields={updateField}
                    />
                  </Row>
                </Form>
              </Col>
              <Col xs={12}>
                <Container className="d-flex mt-3 bg-white p-1 m-1  rounded shadow">
                  <Table>
                    <thead>
                      <tr>
                        <th className="text-nowrap">{t("Currency")}</th>
                        <th className="text-nowrap">{t("Rate Value")}</th>
                        <th className="text-nowrap">{t("Total")}</th>
                        <th className="text-nowrap">{t("Total")} DOP</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(totals).map((total, index) =>
                        [accounts[total][0]].map((account, fIndex) => {
                          return (
                            <React.Fragment key={fIndex}>
                              <tr>
                                <td className="text-no-wrap">
                                  {account.Currency}
                                </td>
                                <td>
                                  {FormatMoney(account.RateValue.toFixed(2))}
                                </td>
                                <td>{FormatMoney(totals[total])}</td>
                                <td className="text-wrap">
                                  {FormatMoney(
                                    (totals[total] * account.RateValue).toFixed(
                                      2
                                    )
                                  )}
                                </td>
                              </tr>

                              {Object.keys(totals).length - 1 === index ? (
                                <tr>
                                  <td>
                                    <h4>{t("Total")}</h4>
                                  </td>

                                  <td className="text-end" colSpan={3}>
                                    <h4>{FormatMoney(sumTotals.toFixed(2))}</h4>
                                  </td>
                                </tr>
                              ) : null}
                            </React.Fragment>
                          );
                        })
                      )}
                    </tbody>
                  </Table>
                </Container>
              </Col>
            </Row>
          </Col>
          {/* MONEY CALCULATOR */}
          <Col xs={6}>
            <Card className="shadow" style={{ backgroundColor: "#F4F4F4" }}>
              <Card.Header className="fs-bolder">
                {t("Calculate Money")}
              </Card.Header>
              <Card.Body>
                <Accordion>
                  {accounts &&
                    Object.keys(accounts).length > 0 &&
                    Object.keys(accounts).map((account, index) => (
                      <Accordion.Item eventKey={index} key={index}>
                        <Accordion.Header className="text-nowrap mb-0 mt-0">
                          {account} - {FormatMoney(totals[account])}
                        </Accordion.Header>

                        <Accordion.Body>
                          <Row>
                            <Col xs={12} className="table-responsive">
                              <table className="table table-striped text-center">
                                <thead>
                                  <tr>
                                    <th className="text-nowrap">
                                      {t("Denomination")}
                                    </th>
                                    <th className="text-nowrap">
                                      {t("Quantity")}
                                    </th>
                                    <th className="text-nowrap">
                                      {t("Amount")}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {accounts[account]
                                    .filter(
                                      (item) => item.CurrencyCode === account
                                    )
                                    .map((item, fIndex, array) => {
                                      const key = `${account}-${item.Denomination}`;

                                      item.Total =
                                        item.Value * (quantities[key] || 0);

                                      return (
                                        <React.Fragment key={fIndex}>
                                          <tr>
                                            <td className="text-no-wrap">
                                              {item.Denomination}
                                            </td>
                                            <td>
                                              {item.CalculationType === "Q" &&
                                              isInProcess ? (
                                                <input
                                                  type="number"
                                                  className="form-control text-center"
                                                  defaultValue={
                                                    quantities[key] || 0
                                                  }
                                                  min={0}
                                                  onChange={(e) => {
                                                    handleQuantityChange(
                                                      account,
                                                      item.Denomination,
                                                      parseInt(
                                                        e.target.value
                                                      ) || 0
                                                    );
                                                  }}
                                                />
                                              ) : (
                                                <span>
                                                  {item.CalculationType === "Q"
                                                    ? quantities[key] || 0
                                                    : item.Value}
                                                </span>
                                              )}
                                            </td>
                                            <td>
                                              {["A", "F"].includes(
                                                item.CalculationType
                                              ) && isInProcess ? (
                                                <input
                                                  type="number"
                                                  className="form-control text-end"
                                                  min={0}
                                                  defaultValue={
                                                    item.Value *
                                                    (quantities[key] || 0)
                                                  }
                                                  onChange={(e) =>
                                                    handleQuantityChange(
                                                      account,
                                                      item.Denomination,
                                                      parseInt(
                                                        e.target.value
                                                      ) || 0
                                                    )
                                                  }
                                                />
                                              ) : (
                                                <span>
                                                  {FormatMoney(
                                                    item.Value *
                                                      (quantities[key] || 0)
                                                  )}
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                          {array.length - 1 === fIndex ? (
                                            <tr>
                                              <td>Total</td>
                                              <td></td>
                                              <td className="text-end">
                                                <span className="text-end">
                                                  {FormatMoney(
                                                    totals[account] || 0
                                                  )}
                                                </span>
                                              </td>
                                            </tr>
                                          ) : null}
                                        </React.Fragment>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </Col>
                          </Row>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                </Accordion>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CashClosingContainer;
